import { useQuery } from "@tanstack/react-query";
import { getProductPublic } from "../api";

export const useGetProductPublic = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["PRODUCT_PUBLIC"],
    queryFn: getProductPublic,
    select: ({ data }) => data,
  });

  return { product: data, isLoading };
};
